<template>
    <div>
        <ui-modal ref="modalVerRecargosAsociados" size="auto"  id="modalVerRecargosAsociados" :title="'Recargos Asociados - ID : ' + current_tariff_id "
            @close="closeModal('modalVerRecargosAsociados')">
            <div v-if="isLoading" class="loading-container">
                <Loading />
            </div>
            

            <div v-else class="w-100">
                <div v-if="recargosAsociados.length == 0 && this.rechargesToDelete.data.length == 0" class="loading-container my-5">
                    <h5 class="text-center "> No se encontraron Recargos Asociados</h5>
                </div>

                <div v-else class="recargos-asociados">

                    <div class="container-fluid">
                        <div class="row w-100">
                            <div class="col-1">
                                <Button
                                    v-if="showAddrecharge"
                                    :size="15"
                                    color="#dc3545"
                                    colorText="#ffffff"
                                    tooltip="Ocultar Agregar Recargo"
                                    icon="fas fa-minus"
                                    round
                                    :width="30"
                                    class="mt-2 mb-3 mr-2"
                                    @click.native = "showAddrecharge = false"
                                    traslate  
                                />
                                <Button
                                    v-else
                                    :size="15"
                                    color="#2c7bcd"
                                    colorText="#ffffff"
                                    tooltip="Agregar Recargo"
                                    icon="fas fa-plus"
                                    round
                                    :width="30"
                                    class="mt-2 mb-3 mr-2"
                                    @click.native = "showAddrecharge = true"
                                    traslate  
                                />
                            </div>
                            <div v-if="showAddrecharge" class="col-3">
                                <ui-select
                                    class="w-100"
                                    has-search
                                    label="Tipo Recargo"
                                    placeholder="Seleccionar"
                                    searchPlaceholder="Buscar"
                                    :keys="{ value: 'id', label: 'name' }"
                                    v-model="tariff_recharges_type"
                                    :options="optionTypeRecharges" 
                                />
                                   
                            </div>
                            <div v-if="showAddrecharge" class="col-2">
                                <ui-select
                                    class="w-100"
                                    has-search
                                    label="Moneda"
                                    placeholder="Seleccionar"
                                    searchPlaceholder="Buscar"
                                    :keys="{ value: 'id', label: 'name' }"
                                    v-model="currency"
                                    :options="optionCurrencies" 
                                />
                            </div>

                            <div v-if="showAddrecharge" class="col-2">
                                <ui-select
                                    class="w-100"
                                    has-search
                                    label="Unidad de Pago"
                                    placeholder="Seleccionar"
                                    searchPlaceholder="Buscar"
                                    :keys="{ value: 'id', label: 'name' }"
                                    v-model="unit_payment"
                                    :options="optionUnitPayments" 
                                />
                            </div>

                            <div v-if="showAddrecharge" class="col-1">

                                <div for="" class="ui-textbox__label-text"> Neta </div>

                                <input 
                                    type="text" 
                                    class="text_field_mask w-100"
                                    v-mask="weightMask"
                                    v-model="neta"
                                />
                            </div>
                            <div v-if="showAddrecharge" class="col-1">

                                <div for="" class="ui-textbox__label-text"> Pública </div>

                                <input 
                                    type="text" 
                                    class="text_field_mask w-100"
                                    v-mask="weightMask"
                                    v-model="public_value"
                                />
                            </div>

                            <div v-if="showAddrecharge" class="col-1">

                                <Button
                                    :size="15"
                                    color="#2da44e"
                                    colorText="#ffffff"
                                    tooltip="Agregar Recargo"
                                    icon="fas fa-plus"
                                    round
                                    :width="30"
                                    class="mt-2 mb-3 mr-2"
                                    @click.native = "storage"
                                    traslate  
                                />
                            </div>
                           
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <table class="table text-center w-100 table-bordered table-hover">

                                    <thead>
                                        <tr >
                                            <th class="bg-beige" colspan="11">Recargos Asociados</th>
                                        </tr>
                                        <tr>
                                            <th>N°</th>
                                            <th>Recargo</th>
                                            <th> Tipo </th>
                                            <th> Desde  </th>
                                            <th> Hasta  </th>
                                            <th> POL </th>
                                            <th> POD </th>
                                            <th> T. Neta   </th>
                                            <th> T. Pública </th>
                                            <th> Descuento </th>
                                            <th> Acciones  </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in recargosAsociados" :key="'o'+i">
                                            <td> {{  (i+1)  }} </td>
                                            <td class="text-left"> {{ item.name }} </td>
                                            <td> <span > {{ item.id_type == 1 ? "Origen" : ""}} {{ item.id_type == 2 ? "Destino" : "" }} {{ item.id_type == 3 ? "Flete" : "" }} </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].from }} </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].to }}  </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].pol_name }}  </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].pod_name }}  </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].currency_code + " " + item.data[0].neta }} </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].currency_code + " " + item.data[0].public_value }} </span> </td>
                                            <td> <span v-if="item.data.length > 0"> {{ item.data[0].currency_code + " " + item.data[0].discount }} </span> </td>
                                            <td> 
                                                <div class="d-flex justify-content-center">
                                                    <Button
                                                        :size="13"
                                                        color="#dc3545"
                                                        colorText="#ffffff"
                                                        tooltip="Eliminar Recargo"
                                                        icon="fa fa-trash-alt"
                                                        round
                                                        :width="25"
                                                        class=""
                                                        @click.native="eliminarRecargo( item.id, i )"
                                                        translate
                                                    />
                                                </div>
                                               
                                            </td>
                                        </tr>

                                        <tr class="table-success">
                                            <th colspan="5"></th>
                                            <th colspan="2">  TOTALES ORIGEN  </th>

                                            <th> {{ totalByOriginNeta }} </th>
                        
                                            <th> {{ totalByOriginPublic }} </th>
                                            <th> {{ totalDiscountOrigin }} </th>
                                            <th> - </th>
                                        </tr>
                                        <tr class="table-success">
                                            <th colspan="5">  </th>
                                            <th colspan="2">TOTALES DESTINO </th>

                                            <th> {{ totalByDestinityNeta }} </th>
                                            <th> {{ totalByDestinityPublic }} </th>
                                            <th> {{ totalDiscountDestinity }} </th>
                                            <th> - </th>
                                        </tr>
                                        <tr class="table-success">
                                            <th colspan="5">  </th>
                                            <th colspan="2"> TOTALES FLETE </th>
                                            <th> {{ totalByFreightNeta }} </th>
                                            <th> {{ totalByFreightPublic }} </th>
                                            <th> {{ totalDiscountFreight }} </th>
                                            <th> - </th>
                                        </tr>
                                    </tbody>


                                </table>

                                <div class="w-100 ">

                                    <Button
                                        text="Cancelar"
                                        class="float-right ml-3 mb-3 mt-1"
                                        :width="90"
                                        :height="38"
                                        color="#c12020"
                                        colorText="#fff"
                                        title="Cancelar"
                                        horizontal
                                        @click.native="closeModal('modalVerRecargosAsociados')"
                                    />

                                    <Button
                                        text  = "Guardar"
                                        :width="90"
                                        :height="38"
                                        class="float-right mb-3 mt-1"
                                        color = "#21831b"
                                        colorText = "#fff"
                                        title = "Guardar"
                                        horizontal
                                        @click.native = "eliminarRecargosAsociados(rechargesToDelete)"
                                    />

                                </div>

                                <table class="table text-center w-100 table-bordered table-hover">
                                    <thead>
                                        <tr >
                                            <th class="bg-beige" colspan="10">Tarifa All In = Ocean Freight + Recargos Flete + Recargos en Origen</th>
                                        </tr>
                                        <tr>
                                            <th> Desde  </th>
                                            <th> Hasta  </th>
                                            <th> POL </th>
                                            <th> POD </th>
                                            <th> T. Pública </th>
                                            <th> T. Neta   </th>
                                            <th> Descuento </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>

                                            <th> {{ this.tariffLine.from_date }} </th>
                                            <th> {{ this.tariffLine.to_date }} </th>
                                            <th> {{ this.tariffLine.pol_name }} </th>
                                            <th> {{ this.tariffLine.pod_name }} </th>
                                            <th> {{ 'USD ' + tariffLine.public_value }} </th>
                                            <th> {{ 'USD ' + tariffLine.neta }} </th>
                                            <th> {{ 'USD ' + tariffLineDiscount }} </th>

                                        </tr>
                                        <tr class="table-success">
                                            <th colspan="3"></th>
                                            <th> TOTAL TARIFA + RECARGOS </th>
                                            <th> {{ tariffRechargePublicString || ('USD ' + tariffRechargePublic) }} </th>
                                            <th> {{ tariffRechargeNetaString || ('USD ' + tariffRechargeNeta) }} </th>
                                            <th> {{ 'USD ' + discountTotal }} </th>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import UiModal from "keen-ui/src/UiModal";
import Loading from "../../../../common/loading.vue";
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

import { verRecargosPorTarifa
    ,eliminarAsignacionTarifasRecargos, 
    selectsRecharges,
    tariffLineStorageRecharge
} from "../../../../../constants/lineas";
import Button from "../../../../common/Button.vue";
import { createNumberMask } from "text-mask-addons";

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6
});

export default {
    components: {
        UiModal,
        Loading,
        Button
    },
    props: {
        id: { type: Number, default: () => 0 }
    },
    data() {
        return {
            weightMask,
            showModal: this.showModalProp,
            recargosAsociados: [],
            rechargesToDelete: {
                data: []
            },
            totalNetas: [],
            isLoading: true,
            totalByOriginNeta    : 0 ,
            totalByDestinityNeta : 0 ,
            totalByFreightNeta   : 0 ,

            totalByOriginPublic    : 0 ,
            totalByDestinityPublic : 0 ,
            totalByFreightPublic   : 0 ,

            totalDiscountOrigin    : "" ,
            totalDiscountDestinity : "" ,
            totalDiscountFreight   : "" ,

            tariffRechargePublic : 0 ,
            tariffRechargeNeta   : 0 ,
            tariffRechargePublicString : null ,
            tariffRechargeNetaString   : null ,
            discountTotal   : 0 ,
            tariffLineDiscount : 0 ,
            tariffLine : {},

            current_tariff_id: 0 ,

            optionTypeRecharges : [],
            optionCurrencies    : [],
            optionUnitPayments  : [],
            
            showAddrecharge : false ,

            tariff_recharges_type : {} ,
            currency     : {} ,
            unit_payment : {} ,
            neta : "" ,
            public_value : "" ,

        }
    },
    computed: {
        ...mapState("lineas", ["visibleModalVerRecargosAsociados", "tariffSelectedRechargeAction", 'dataRecargosAsociados']),
    },
    methods: {

        ...mapActions(["ActionSetZindexModal"]),
        ...mapActions("lineas", ["actionSetVisibleModalVerRecargosAsociados", "actionTariffSelectedRechargeAction", 'actionSetDataRecargosAsociados']),
        openModal(ref) {
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.actionSetVisibleModalVerRecargosAsociados(false);
            this.actionTariffSelectedRechargeAction(undefined);
            this.actionSetDataRecargosAsociados(null);
            this.ActionSetZindexModal(false);
            this.recargosAsociados = [];
            this.rechargesToDelete.data = [];
            this.$refs[ref].close();
        },
        /** @param { int } id - id de la asignación en la tabla pivot tariffLineRechargeType */
        /** @param { string } name - nombre del tipo de recargo */
        async eliminarRecargo( id, index ) {

            this.recargosAsociados  = this.recargosAsociados.filter( ( ra, i) => index != i ) ;
            
            this.rechargesToDelete.data.push( id );

        },
        async eliminarRecargosAsociados( data ){

            console.log("this.dataRecargosAsociados -->" , this.dataRecargosAsociados ) ;
            
            const response = await this.$vToastify.prompt({
                body: `¿Desea eliminar los recargos asociados?`,
                answers: { Sí: true, No: false },
            });

            if ( response ) {

                try {

                    this.$vToastify.loader("Eliminando recargos asociados...");

                    await eliminarAsignacionTarifasRecargos(data);
                    this.getRecharges(this.dataRecargosAsociados);
                    this.rechargesToDelete.data = [];
                    this.$vToastify.stopLoader();
                    this.$vToastify.success(`Recargando recargos asociados`, 'Realizado!');
                    this.isLoading = true;

                } catch (err) {
                    this.$vToastify.error('Seleccione al menos un recargo.', 'Error!');
                }

                
            }


        },
        /** @param { int } id - id de la tarifa*/
        async getRecharges(id) {

            this.isLoading = true;
            const { data } = await verRecargosPorTarifa(id);


            this.totalByOriginNeta    = data.totals.tariff_recharges_total_origin_neta ;
            this.totalByDestinityNeta = data.totals.tariff_recharges_total_destinity_neta ;
            this.totalByFreightNeta   = data.totals.tariff_recharges_total_freight_neta ;

            this.totalByOriginPublic    = data.totals.tariff_recharges_total_origin_public ;
            this.totalByDestinityPublic = data.totals.tariff_recharges_total_destinity_public ;
            this.totalByFreightPublic   = data.totals.tariff_recharges_total_freight_public ;

            this.totalDiscountOrigin    = data.totals.tariff_total_origin_discount ;
            this.totalDiscountDestinity = data.totals.tariff_total_destinity_discount ;
            this.totalDiscountFreight   = data.totals.tariff_total_freight_discount ;

            this.tariffRechargePublic = data.totals.tariff_recharge_total_public ;
            this.tariffRechargeNeta   = data.totals.tariff_recharge_total_neta ;

            this.tariffRechargePublicString = data.totals.tariff_recharge_total_public_string ;
            this.tariffRechargeNetaString   = data.totals.tariff_recharge_total_neta_string ;

            this.discountTotal = data.totals.discount_total ;

            this.tariffLineDiscount = data.totals.tariff_line_discount ;

            this.tariffLine = data.tariff_line ;

            this.recargosAsociados = data.data.sort( (a,b) => a.id_type - b.id_type );

            this.isLoading = false;
        },
        async init(){

            const { currencies, typesRecharges, unitPayments } = await selectsRecharges() ;

            this.optionCurrencies =  currencies ;
            this.optionTypeRecharges =  typesRecharges ;
            this.optionUnitPayments  =  unitPayments ;
        },
        async storage(){

            if( !this.tariff_recharges_type.id ){
                this.$vToastify.warning("Campo 'Tipo Recargo' requerido", "¡Alerta!");
                return ;
            }

            if( !this.currency.id ){
                this.$vToastify.warning("Campo 'Moneda' requerido", "¡Alerta!");
                return;
            }

            if( !this.unit_payment.id ){
                this.$vToastify.warning("Campo 'Unidad De Pago' requerido", "¡Alerta!");
                return;
            }

            if( !this.neta ){
                this.$vToastify.warning("Campo 'Neta' requerido", "¡Alerta!");
                return;
            }

            if( !this.public_value ){
                this.$vToastify.warning("Campo 'Pública' requerido", "¡Alerta!");
                return;
            }

            const payload = {
                tariff_recharges_type : this.tariff_recharges_type.id ?? null,
                unit_payment    : this.unit_payment.id ?? null,
                currency_id     : this.currency.id ?? null,
                neta            : +this.neta ,
                public_value    : +this.public_value ,
                id_tariff_line  : +this.current_tariff_id ,
            };

            this.$vToastify.loader("Agregando Recargos, espere...");

            try {
                
                await tariffLineStorageRecharge( payload );

                await this.getRecharges( payload.id_tariff_line );

                this.$vToastify.stopLoader();

                return this.$vToastify.success("Se han agregado recargos", "Realizado");

            } catch (error) {

                this.$vToastify.stopLoader();

                return this.$vToastify.error("Hubo un problema al agregar recargos. Favor, recargar página y volver a intentar.", "Error");
            }
        },
        clearForm(){
            this.neta = "" ;
            this.public_value = "" ;
            this.tariff_recharges_type = {} ;
            this.currency =   {} ;
            this.unit_payment = {} ;
        }
    },
  beforeMount() {

      this.current_tariff_id =  this.id;

  },
  created(){

    this.init()
    
  },
  watch: {
        visibleModalVerRecargosAsociados: function (_new) {

            _new && this.openModal('modalVerRecargosAsociados');

        },
        recargosAsociados : function( _new ){

            if(  _new.length > 0 ){
                const idsType = _new.map( tr => tr.id_tariff_recharge_type );
                this.optionTypeRecharges = this.optionTypeRecharges.filter( t => !idsType.includes( t.id ) ) ;
            }
        },
        dataRecargosAsociados: function (_new) {

            if (_new) {

                this.current_tariff_id = _new ;

                this.getRecharges(_new);

            }

            else {

                this.current_tariff_id = 0;

            }

        }
    },
}
</script>

<style lang="scss" scoped>

    #modalVerRecargosAsociados .ui-modal__container{
        width: 83% !important;
    }

    #modalVerRecargosAsociados .bg-beige{
        background-color: beige;
    }

    
    .loading-container {
        width: 80vw;
    }

    #modalVerRecargosAsociados .text_field_mask {
        background: none;
        border: none;
        border-bottom-color: rgba(0, 0, 0, 0.12);
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-radius: 0;
        color: rgba(0, 0, 0, 0.87);
        cursor: auto;
        display: block;
        font-family: inherit;
        font-size: 1rem;
        font-weight: normal;
        margin: 0;
        outline: none;
        padding: 0;
        transition: border 0.1s ease;
        width: 100%;
        height: 32px;
    }

    .recargos-asociados {
        width: 80vw;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 2rem;
        gap: 1rem;

        &__container {
            grid-row: 1/2;
            grid-column: 1/2;
            overflow: auto;

            &-recargos {
                margin-bottom: 20px;

                &-title {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }

                &-info {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;


                    &-item {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        color: #178533;
                        border: 1px solid #1785338a;
                        padding: 5px 10px;
                        border-radius: 5px;
                        margin-bottom: 5px;

                        &-data {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 16px;
                            gap: 20px;
                        }

                        &-value {
                            color: #178533;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            gap: 3px;
                        }
                    }
                }
            }
        }

        &__actions {
            grid-row: 2/3;
            grid-column: 1/2;
            display: flex;

            &-values {

                font-size: 18px;

                &-item {
                    width: 80px;
                    height: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;

                    p {
                        font-size: 18px;
                        margin-top: 15px;
                    }
                }
            }

            &-btn {
                width: 10%;
                height: 100%;
            }
        }
    }

    .text-strong {
        font-weight: bold;
    }

    .not-found-recharge {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #c5c5c5;
        padding: 5px 10px;
        border-radius: 5px;
        margin-bottom: 5px;
    }

    .btn__delete {
        margin-right: 10px;
        font-size: 1.2rem;
        color: #dc143c;
        cursor: pointer;
        transition: transform .3s ease-out;

        &:hover {
            transform: scale(1.5);
        }
    }
</style>